import { Tracking } from '@gjensidige/core-analytics';

const tracker = new Tracking({
  application_module: '',
  application_name: 'calculation-header',
  application_partner: '',
  application_version: '',
  business_area: '',
  customer_segment: '',
  page_pathname: '',
  page_title: '',
  scenario_name: '',
  scenario_step: ''
});

export default tracker;